<!-- src/admin/layouts/AdminLayout.vue -->
<template>
  <div class="admin-layout" :style="{ '--navbar-height': `${navbarHeight}px` }">
    <!-- Sidebar stays pinned below the navbar while the page scrolls -->
    <AdminSidebar class="sidebar" />

    <!-- Main content fills the remaining width -->
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import AdminSidebar from '@/components/admin/AdminSidebar.vue'

// The global AppNavbar is sticky and shrinks on scroll, so track its live height
// to pin the sidebar directly beneath it.
const navbarHeight = ref(0)
let observer = null

onMounted(() => {
  const navbar = document.querySelector('.navbar')
  if (!navbar) return
  const update = () => { navbarHeight.value = navbar.offsetHeight }
  update()
  observer = new ResizeObserver(update)
  observer.observe(navbar)
})

onUnmounted(() => {
  if (observer) observer.disconnect()
})
</script>

<style scoped>
/* Flex row: sidebar | content. No overflow here — it would break position: sticky. */
.admin-layout {
  display: flex;
  align-items: flex-start;
}

/* Sidebar: fixed width, pinned below the navbar, scrolls internally if taller than the screen */
.sidebar {
  width: 240px;
  flex-shrink: 0;
  position: sticky;
  top: var(--navbar-height, 0px);
  height: calc(100vh - var(--navbar-height, 0px));
  overflow-y: auto;
  background-color: #1e3a8a;
  color: #ffffff;
  padding: 16px;
  box-sizing: border-box;
}

/* Main content: takes the rest of the width */
.main-content {
  flex: 1;
  min-width: 0;
  padding: 24px;
  background-color: #f0f4f8;
}

/* Responsive: hide sidebar on small screens */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
</style>
